import { sb } from '../plugins/sendbird';
import { BaseModel } from './BaseModel';
export class SendbirdUser extends BaseModel {
  static get entity() {
    return 'sendbird-users';
  }

  static get fk() {
    return 'sendbird_user_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      userId: this.string(''),
      connectionStatus: this.string(''),
      friendDiscoveryKey: this.attr(null),
      friendName: this.attr(null),
      isActive: this.boolean(false),
      lastSeenAt: this.number(0),
      metaData: this.attr({}),
      nickname: this.string(''),
      plainProfileUrl: this.attr(null),
      requireAuth: this.boolean(false),
      unreadMessageCount: this.number(0)
    };
  }

  static get globalApiConfig() {
    return {
      baseURL: `https://api-${process.env.VUE_APP_SENDBIRD_APP_ID}.sendbird.com/v3`,
      headers: {
        'Api-Token': process.env.VUE_APP_SENDBIRD_API_TOKEN
      }
    };
  }

  static isConnected(id) {
    return SendbirdUser.query().count(id) !== 0;
  }

  static unreadMessagesAll(userId) {
    const userSendbird = this.find(userId);

    return userSendbird ? userSendbird.unreadMessageCount : 0;
  }

  static getTotalUnreadMessageCount(userId) {
    return sb.getTotalUnreadMessageCount(function (count, error) {
      if (error) {
        // Handle error.
      }

      SendbirdUser.update({
        where: userId,
        data: { unreadMessageCount: count }
      });

      return count;
    });
  }

  static apiConfig = {
    actions: {
      findByUserId(user_id = '') {
        return this.get(`/users/${user_id}`);
      },

      create(body = '') {
        return this.post(`/users`, body);
      },

      userConnect(user) {
        let { id, firstname, lastname } = user;

        let name = '';

        if (firstname) {
          name = firstname;
        }

        if (lastname) {
          name += ` ${lastname}`;
        }

        return sb.connect(`${id}`, function (user, error) {
          if (error) {
            console.error(error);
          }

          if (user) {
            sb.updateCurrentUserInfo(name, '');

            SendbirdUser.insert({ data: { ...user, id: user.userId } });
          }

          return user;
        });
      },

      userDisconnect() {
        SendbirdUser.deleteAll();

        return sb.disconnect();
      }
    }
  };
}

export default SendbirdUser;
